export default "__VITE_ASSET__Bfv_3ZfT__"